import React from "react";
import "bootstrap-icons/font/bootstrap-icons.css";
import Counter from "./Counter";

const CountSection = () => {
  return (
    <section id="counts" className="counts">
      <div className="landingContainer" data-aos="fade-up">
        <div className="row">
          <div className="col-lg-3 col-md-6">
            <div className="count-box">
              <i className="bi bi-emoji-smile"></i>
              <Counter start={0} end={2} duration={0.02} />{" "}
              <p>Clientes satisfechos</p>
            </div>
          </div>
          <div className="col-lg-3 col-md-6 mt-5 mt-md-0">
            <div className="count-box">
              <i className="bi bi-journal-richtext"></i>
              <Counter start={0} end={14} duration={0.02} />{" "}
              <p>Torneos creados</p>
            </div>
          </div>
          <div className="col-lg-3 col-md-6 mt-5 mt-lg-0">
            <div className="count-box">
              <i className="bi bi-headset"></i>
              <Counter start={0} end={107} duration={0.02} />{" "}
              <p>Fechas diagramadas</p>
            </div>
          </div>
          <div className="col-lg-3 col-md-6 mt-5 mt-lg-0">
            <div className="count-box">
              <i className="bi bi-people"></i>
              <Counter start={0} end={2} duration={0.02} />{" "}
              <p>Trabajadores activos</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CountSection;
